module.exports = __webpack_public_path__ + "static/media/IMG_20190826_153823.image.3b85188c.png";